import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getCountries } from '@/services/api/mainstream/countries';

const QUERY_KEY = ['mainstream', 'countries'];

export const mainstreamCountriesQueryOptions = queryOptions({
  gcTime: Number.POSITIVE_INFINITY,
  staleTime: Number.POSITIVE_INFINITY,
  queryFn: getCountries,
  queryKey: QUERY_KEY,
});

export const useMainstreamCountries = () => {
  const queryResult = useQuery(mainstreamCountriesQueryOptions);

  const countriesAsOptions = useMemo(() => {
    return Object.entries(queryResult.data ?? {}).map(([key, country]) => ({
      label: country.name,
      value: key,
    }));
  }, [queryResult.data]);

  return {
    ...queryResult,
    countriesAsOptions,
  };
};
